import TrendingNews from "../../components/re-usable/homeTopArticles/trending-news";
import FeaturedBooks from "../../components/re-usable/homeTopArticles/featured-books";
import FeaturedLearning from "../../components/re-usable/homeTopArticles/featured-learning";
import PopularEvents from "../../components/re-usable/homeTopArticles/popular-events";

const NewsAndEvents = () => {
  return (
    <div className="container">
      <div className="row">
      <div className="col-sm-12">
        <div className="row">
          <TrendingNews />
          <FeaturedBooks />
          <PopularEvents />
          <FeaturedLearning />
          
        </div>
      </div>
      </div>
    </div>
  );
};

export default NewsAndEvents;
